import ModalContainer from "./Modal";
const Modal = ModalContainer;
export default Modal;
